import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { useContent } from "@/context/ContentContext";

const FALLBACK = {
  eyebrow: "Why Morning Soft",
  title: "Built around one simple idea. Every day should begin with comfort.",
  pillars: [
    { icon: "Sparkles", title: "Premium Softness", desc: "Luxury feel every time you reach for it. Dermatologist tested." },
    { icon: "ShieldCheck", title: "Dependable Strength", desc: "2-ply strong, engineered to hold up when the day gets messy." },
    { icon: "PiggyBank", title: "Everyday Value", desc: "Family sizes and honest prices that make sense at the checkout." },
    { icon: "Home", title: "Made for Modern Homes", desc: "Household paper and care essentials, designed for how you live." },
  ],
};

export default function WhyMorningSoft() {
  const { content } = useContent();
  const w = content?.why ? { ...FALLBACK, ...content.why } : FALLBACK;
  return (
    <section className="bg-white border-y border-slate-100" data-testid="why-morning-soft" id="why">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 md:py-24">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.3em] text-amber-500 font-bold">{w.eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-black text-[#0f2a5c] tracking-tight leading-[1.04]">
            {w.title}
          </h2>
        </div>
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6">
          {(w.pillars || []).map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={p.title + i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="text-center"
                data-testid={`pillar-${(p.title || '').toLowerCase().replace(/\s/g, "-")}`}
              >
                <div className="mx-auto w-14 h-14 rounded-2xl bg-sky-50 flex items-center justify-center text-[#173a7a]">
                  <Icon size={24} />
                </div>
                <p className="mt-5 font-display font-bold text-lg text-slate-900">{p.title}</p>
                <p className="mt-2 text-sm text-slate-500 leading-relaxed max-w-[220px] mx-auto">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
